<mat-card data-at-remote-diagnostics-warning-modal>
  <mat-card-header>
    <mat-card-title class="!flex flex-row justify-between items-center">
      <span>{{ 'DIAGNOSTICS.CONNECTION_MODAL.WARNING_TITLE' | translate }}</span>
      <mat-icon
        data-at-remote-diagnostics-warning-modal-cancel
        gtm="onCancelDialog"
        gtmCategory="diagnosticsModal"
        class="mat-dialog-close"
        [mat-dialog-close]
        >close</mat-icon
      >
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <p>
      {{ 'DIAGNOSTICS.CONNECTION_MODAL.WARNING_TEXT' | translate }}
    </p>
  </mat-card-content>
  <mat-card-actions class="!flex flex-row gap-[8px] justify-end items-center">
    <button
      data-at-remote-diagnostics-warning-modal-start
      mat-raised-button
      gtm="onNextStep"
      gtmCategory="diagnosticsModal"
      color="primary"
      (click)="start()"
    >
      {{ 'GENERAL.BUTTON.START' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
